import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; 
import "./qualifications.css";

export default function Qualifications() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <div className="qualifications-container">
      {/* SIDEBAR NAVIGATION */}
      <aside className="qualifications-sidebar">
        <nav className="qualifications-nav">
          <a href="#qualifications">Qualifications</a>
          <a href="#registration">Requirements</a>
          <a href="#rates">Registration Rates</a>
          <a href="#partnerships">Partnership Packages</a>
          <a href="#payment">Payment & Contact</a>
        </nav>

        {/* REGISTRATION BUTTON */}
        <a 
          href="https://tinyurl.com/BnT-2026-Registration" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="register-btn"
        >
          REGISTER NOW
        </a>
      </aside>

      <div className="qualifications-content">
        
        {/* SECTION 1: QUALIFICATIONS */}
        <section id="qualifications" className="qual-section">
          <h2>Event Qualifications</h2>
          <hr className="qual-divider" />
          
          <div className="rules-grid">
            <div className="rules-list full-width">
              <h3>Participant Eligibility</h3>
              <ul>
                <li>Bonafide students currently enrolled under the Bachelor of Science in Electronics and Communications Engineering/Electronics Engineering (BSECE) shall be eligible to join.</li>
                <li>Only one (1) coach shall accompany the participants of each participating institution.</li>
                <li>He/she should be a bonafide faculty member of the institution they are representing.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* SECTION 2: REQUIREMENTS (ID changed to "registration" for the Scrollspy) */}
        <section id="registration" className="qual-section">
          <h2>Registration Requirements</h2>
          <hr className="qual-divider" />
          <p className="section-intro">
            Registrants shall accomplish their registration and must submit a copy of the following documents via Google forms:
          </p>

          <div className="callout-box" style={{ borderRadius: '8px', borderLeft: '4px solid #18a518', marginBottom: '30px' }}>
            <h3>Required Documents</h3>
            <ul>
              <li>School ID</li>
              <li>Proof of Enrollment</li>
              <li>Proof of Payment</li>
            </ul>
          </div>
        </section>

        {/* SECTION 3: RATES */}
        <section id="rates" className="qual-section">
        <h2>Registration Rates</h2>
        <hr className="qual-divider" />
        <p className="section-intro" style={{marginBottom: '20px'}}>
            All registrations include one (1) lunch and (1) snack and official limited edition BNT 2026 merchandise.
        </p>

        <div className="stats-row"> 
            <div className="stat-box">
                <i className="fas fa-clock"></i>
                <div>
                    <strong>Early Bird</strong>
                    <p><span>Php 540</span> | On or before March 07</p>
                </div>
            </div>
            
            <div className="stat-box">
                <i className="fas fa-calendar-check"></i>
                <div>
                    <strong>Regular</strong>
                    <p><span>Php 600</span> | March 08 to March 22</p>
                </div>
            </div>
            
            <div className="stat-box">
                <i className="fas fa-exclamation-circle"></i>
                <div>
                    <strong>Late</strong>
                    <p><span>Php 650</span> | March 23 to April 5</p>
                </div>
            </div>
        </div>

        <div className="rates-cta">
            <a 
            href="https://tinyurl.com/BnT-2026-Registration" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-register-btn"
            >
            Secure Your Slot Now
            </a>
        </div>
        </section>

        {/* SECTION 4: PARTNERSHIP PACKAGES */}
        <section id="partnerships" className="qual-section">
          <h2>Partnership Packages</h2>
          <hr className="qual-divider" />
          <p className="section-intro" style={{marginBottom: '20px'}}>
             Schools that avail of partnership packages are eligible for discounted registration fees during the regular registration period.
          </p>
          
          {/* Gold Package */}
          <div className="unified-k-box final-round-accent" style={{marginBottom: '15px'}}>
            <div className="k-header-main"><h3 style={{color: '#ffd700'}}>Gold Package</h3></div>
            <div className="k-grid-internal">
              <div className="k-col">
                <strong>Requirements</strong>
                <p>Required minimum of eight (8) participants.</p>
              </div>
              <div className="k-col">
                <strong>Rate</strong>
                <p>Php 540 per participant.</p>
              </div>
            </div>
          </div>

          {/* Silver Package */}
          <div className="unified-k-box" style={{borderTopColor: '#c0c0c0', marginBottom: '15px'}}>
            <div className="k-header-main"><h3 style={{color: '#c0c0c0'}}>Silver Package</h3></div>
            <div className="k-grid-internal">
              <div className="k-col">
                <strong>Requirements</strong>
                <p>Required minimum of five (5) participants.</p>
              </div>
              <div className="k-col">
                <strong>Rate</strong>
                <p>Php 555 per participant.</p>
              </div>
            </div>
          </div>

          {/* Bronze Package */}
          <div className="unified-k-box" style={{borderTopColor: '#cd7f32'}}>
            <div className="k-header-main"><h3 style={{color: '#cd7f32'}}>Bronze Package</h3></div>
            <div className="k-grid-internal">
              <div className="k-col">
                <strong>Requirements</strong>
                <p>Required minimum of three (3) participants.</p>
              </div>
              <div className="k-col">
                <strong>Rate</strong>
                <p>Php 570 per participant.</p>
              </div>
            </div>
          </div>
          {/* LEARN MORE BUTTON */}
        <div className="learn-more-container">
        <a 
            href="/packages"   
            className="learn-more-btn"
        >
            Learn More
        </a>
        </div>
        </section>

        {/* SECTION 5: PAYMENT & CONTACT */}
        <section id="payment" className="qual-section">
          <h2>Payment & Contact</h2>
          <hr className="qual-divider" />
          
          <div className="rules-grid">
            <div className="callout-box" style={{ borderRadius: '8px', borderLeft: '4px solid #18a518' }}>
              <h3>Payment Channels</h3>
              <ul style={{listStyle: 'none', padding: 0}}>
                <li style={{marginBottom: '15px'}}>
                  <strong style={{color: '#ffffff', display: 'block'}}>G-Cash</strong>
                  Joshua Dela Cruz<br/>09915382702
                </li>
                <li>
                  <strong style={{color: '#ffffff', display: 'block'}}>BPI Bank Transfer</strong>
                  Joshua Dela Cruz<br/>8119299107
                </li>
              </ul>
            </div>
            
            <div className="rules-list">
              <h3>Reminders & Inquiries</h3>
              <ul style={{marginLeft: '0'}}>
                <li>Proof of payment must be submitted via the provided Google Form.</li>
                <li>Once the confirmation email is received, the organizing committee will issue an official e-receipt.</li>
                <li style={{marginTop: '15px'}}><strong>Email:</strong> oeces@tup.edu.ph</li>
                <li><strong>Alethea Rañosa:</strong> +639165456990</li>
                <li><strong>Joshua Dela Cruz:</strong> +63915382702</li>
                <li><strong>Maverin Allysandra:</strong> +63938134856</li>
              </ul>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}